// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { __rest } from "tslib";
import React, { useState } from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import { fireNonCancelableEvent } from '../internal/events';
import styles from './styles.css.js';
export default function InternalFileDropzone(_a) {
    var { onChange, children, __internalRootRef = null } = _a, restProps = __rest(_a, ["onChange", "children", "__internalRootRef"]);
    const [isDropzoneHovered, setDropzoneHovered] = useState(false);
    const baseProps = getBaseProps(restProps);
    const onDragOver = (event) => {
        event.preventDefault();
        if (event.dataTransfer) {
            setDropzoneHovered(true);
            event.dataTransfer.dropEffect = 'copy';
        }
    };
    const onDragLeave = (event) => {
        event.preventDefault();
        setDropzoneHovered(false);
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'none';
        }
    };
    const onDrop = (event) => {
        event.preventDefault();
        setDropzoneHovered(false);
        fireNonCancelableEvent(onChange, { value: Array.from(event.dataTransfer.files) });
    };
    return (React.createElement("div", Object.assign({}, baseProps, { ref: __internalRootRef, className: clsx(baseProps.className, styles.root, {
            [styles.hovered]: isDropzoneHovered,
        }), onDragOver: onDragOver, onDragLeave: onDragLeave, onDrop: onDrop }),
        React.createElement("div", { className: styles.content }, children)));
}
//# sourceMappingURL=internal.js.map